module.exports = __webpack_public_path__ + "media/styles/images/png/pen-white-09f9936953dcaa7ad5f8fed449f7c248.png";